function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["id", "items", "currentItem", "setPageTitle", "color", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import IconLinkCaretRight from '@lmig/lmds-react-icons/dist/icons/LinkCaretRight';
import "./Wayfinder.css";
export var Wayfinder = function Wayfinder(_ref) {
  var id = _ref.id,
    items = _ref.items,
    currentItem = _ref.currentItem,
    _ref$setPageTitle = _ref.setPageTitle,
    setPageTitle = _ref$setPageTitle === void 0 ? false : _ref$setPageTitle,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'lightGray' : _ref$color,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  React.useEffect(function () {
    if (setPageTitle && document) {
      var titleEl = document.querySelector('title');
      var originalTitle = titleEl && titleEl.getAttribute('data-originaltitle') || document.title;
      if (titleEl) {
        titleEl.setAttribute('data-originaltitle', originalTitle);
      }
      document.title = "".concat(currentItem, " | ").concat(originalTitle);
    }
    return function cleanup() {
      if (setPageTitle && document) {
        var _titleEl = document.querySelector('title');
        var _originalTitle = _titleEl && _titleEl.getAttribute('data-originaltitle');
        document.title = _originalTitle || document.title;
      }
    };
  }, [setPageTitle, currentItem]);
  return /*#__PURE__*/React.createElement("div", _extends({
    id: id,
    className: classNames('lm-Wayfinder', _defineProperty({}, "lm-Wayfinder--color-".concat(color), color && color !== 'lightGray'), className)
  }, otherProps), /*#__PURE__*/React.createElement("ul", null, items.map(function (item, key) {
    var itemKey = "item-".concat(key);
    return /*#__PURE__*/React.createElement("li", {
      key: itemKey,
      className: item === currentItem ? 'is-current' : undefined
    }, item, items[items.length - 1] !== item && /*#__PURE__*/React.createElement(IconLinkCaretRight, {
      className: "lm-Wayfinder-caret"
    }));
  })));
};
Wayfinder.propTypes = {
  /** Add an optional ID to this element: `<div class="lm-Wayfinder">`. */id: _pt.string,
  /** Add custom classes to this element: `<div class="lm-Wayfinder">`. */className: _pt.string,
  /** An array of strings passed in order. */items: _pt.arrayOf(_pt.node).isRequired,
  /** CurrentItem must match one of the "items" exactly. */currentItem: _pt.node,
  /** Experimental: if true, this will set the page title in the DOM to the currentItem.
     * @default false
     */
  setPageTitle: _pt.bool,
  /** Specify the default text and caret color. `darkGray` is for use on yellow backgrounds.
     * @default 'lightGray'
     */
  color: _pt.oneOf(['lightGray', 'darkGray'])
};